<template>
  <div id="app">
    <offline-indicator :hideOnOnline="false"></offline-indicator>
    <sign v-show="currentUser === null"></sign>

    <router-view v-show="currentUser !== null && !showItemEditor"></router-view>
    <item-editor v-show="currentUser !== null && showItemEditor"></item-editor>

  </div>
</template>

<script>
import Sign from './views/Sign.vue'
import ItemEditor from './views/ItemEditor.vue'
import OfflineIndicator from './components/OfflineIndicator.vue'
// import is from 'is_js'

export default {
  name: 'App',
  components: {
    Sign,
    ItemEditor,
    OfflineIndicator
  },
  data () {
    return {}
  },
  beforeCreate: function () {
    // listen to event from firebase service or local db
    document.addEventListener('FIRE-SERVICE-EVENT-TO-VUEX', this.handleIncomingEvent)
    document.addEventListener('LOCAL-DB-EVENT-TO-VUEX', this.handleIncomingEvent)
  },
  created: function () {
    // init user data
    // this.initUser()
    // init database data
    this.$store.dispatch('initApp')
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.currentUserInfo
    },
    showItemEditor: function () {
      return this.$store.state.showItemEditor
    }
  },
  methods: {
    initUser: function () {
      this.$store.dispatch('initUser')
    },
    handleFireServiceEvent: function (event) {
      this.$store.dispatch('handleEvent', event.detail)
    },
    handleIncomingEvent: function (event) {
      this.$store.dispatch('handleIncomingEvent', event)
    }
  }
}
</script>

<style lang="scss">
.grecaptcha-badge { visibility: hidden; }
</style>
